import { useCallback, useEffect, useState } from "react";
import axiosInstance from "../config/axiosInstance";
import { extractList } from "../utils/api";
import { getStoredUser } from "../utils/auth";

const resolveCompanyIdFromUser = (user) => {
  if (!user) return null;
  return user.companyId || user.Company?.id || user.company?.id || null;
};

export const useCompany = () => {
  const [company, setCompany] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      setLoading(true);
      const storedUser = getStoredUser();
      const companyId = resolveCompanyIdFromUser(storedUser);

      if (companyId) {
        const response = await axiosInstance.get(`/companies/${companyId}`);
        const data = response?.data?.data || response?.data || null;
        setCompany(data || null);
        return;
      }

      // Fallback para contas antigas sem companyId no user salvo.
      const response = await axiosInstance.get("/companies", {
        params: { itemsPerPage: -1 },
      });
      const list = extractList(response);
      const userId = storedUser?.id;
      const found = list.find((item) => item.userId === userId) || null;
      setCompany(found);
    } catch (error) {
      setCompany(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    refresh();
  }, [refresh]);

  return { company, setCompany, loading, refresh };
};
